// This may need to be tweaked in order to support more than just "patient count", but for now it's fine.
import React from 'react';
import { VictoryPie } from 'victory';
import Divider from '../../../ui_kit/utilities/divider';

import styles from './index.module.css';

const PieChart = ({ title, data, subHeading = null }) => {
  if (!data) {
    return <></>;
  }

  const colors = [
    '#59b6be',
    '#578ec5',
    '#7974b4',
    '#935791',
    '#9c3d62',
    '#69d9b0',
    '#324b4d',
    '#94b0b3',
    '#d393d2',
    '#c5a45b',
    '#0e6855',
    '#00a9be',
  ];

  const patientCount = data.total;
  const results = data.results;

  const renderKey = (color, text) => {
    return (
      <div className='row' key={text}>
        <div className='col-2'>
          <div style={{ background: color }} className={styles.key}></div>
        </div>
        <div className='col-10' style={{ textAlign: 'left' }}>
          <p className={styles.bold_black_text}>{text}</p>
        </div>
      </div>
    );
  };

  let total = 0;
  let keys = Object.keys(results);
  keys.forEach((key) => {
    total = total + results[key];
  });

  const graphicData = keys.map((key) => ({
    x: `${Math.ceil((results[key] / patientCount) * 100)}` || 0,
    y: results[key] || 0,
    label: `${Math.ceil((results[key] / patientCount) * 100)}%` || 0,
  }));

  let graphicColor = colors.slice(0, keys.length);

  const subTitle = `${patientCount} total mentees`;

  return (
    <>
      <div className={`${styles.gray_header} marg-bottom-10`}>{title}</div>
      {subHeading && <div className={`${styles.gray_subheader}`}>{subHeading}</div>}
      <div className={`${styles.gray_subheader}`}>{subTitle}</div>
      <div className='row'>
        <div className='col-lg-6'>
          <div style={{ padding: '50px 20px' }}>
            {keys.map((key, i) => (
              <React.Fragment key={key}>
                {renderKey(graphicColor[i], key)}
                {i !== keys.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </div>
        </div>
        <div className='col-lg-6'>
          <VictoryPie
            key={`${title}-${JSON.stringify(graphicData)}`}
            animate={{ easing: 'bounce' }}
            data={graphicData}
            colorScale={graphicColor}
            style={{ labels: { fontSize: 16, fill: 'white', fontFamily: 'HK Grotesk', fontWeight: '600' } }}
            labelRadius={50}
          />
        </div>
      </div>
    </>
  );
};

export default PieChart;
